export default function DataTableBody({
  getTableBodyProps,
  prepareRow,
  page,
  additionalColumns = (row) => null,
  onClickRow = () => { }
}) {

  return (
    <tbody {...getTableBodyProps()}>
      {page.map((row) => {
        prepareRow(row);
        const rowProps = row.getRowProps();
        const { key, ...restRowProps } = rowProps || {};
        return (
          <tr key={key} {...restRowProps} onClick={() => onClickRow(row.original)}>
            {row.cells.map((cell) => {
              const cellProps = cell.getCellProps();
              const { key: cellKey, ...restCellProps } = cellProps || {};
              const tooltipValue =
                typeof cell.value === "string" || typeof cell.value === "number"
                  ? String(cell.value)
                  : undefined;
              return (
                <td
                  key={cellKey}
                  {...restCellProps}
                  className="data-table-data"
                  data-cell={cell.column.id}
                  title={tooltipValue}
                >
                  {cell.render("Cell")}
                </td>
              );
            })}
            {additionalColumns(row)}
          </tr>
        );
      })}
    </tbody>
  );
}
